import { Box, Typography, Button } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { colors } from 'src/styles/theme';

const TREASURER_PAYMENT_URL =
  'https://secureinstantpayments.com/sip/reports/account_selector.php?FromPopup=1&Merchant=33909';

const BackTaxWarning = ({ balanceDue }) => {
  const formattedBalance = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(balanceDue);

  const handlePayNowClick = () => {
    window.open(TREASURER_PAYMENT_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: colors.warning.light,
        border: `1px solid ${colors.warning.border}`,
        borderRadius: '8px',
        padding: '12px 16px',
        marginBottom: '1.5rem',
        width: '100%',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <WarningAmberIcon sx={{ color: colors.warning.icon, fontSize: '28px' }} />
        <Box>
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: '1.25rem',
              color: colors.warning.brownTitle,
            }}
          >
            Outstanding Prior-Year Balance
          </Typography>
          <Typography sx={{ fontSize: '1rem', color: colors.warning.brownSubtitle }}>
            You still owe {formattedBalance} from previous tax years.
          </Typography>
        </Box>
      </Box>
      <Button
        variant="contained"
        onClick={handlePayNowClick}
        sx={{
          backgroundColor: colors.secondary.main,
          color: colors.white,
          textTransform: 'none',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: colors.secondary.dark,
          },
        }}
      >
        Pay Now
      </Button>
    </Box>
  );
};

export default BackTaxWarning;
